"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=basePanelConfig.js.map